import {
  prepareRequest
} from './request'

// Submit

export const submitOrderCashout = data => {
  const request = prepareRequest({
    url: 'ordering/cash-out:order',
    method: 'POST'
  })

  return request(data)
}

export const submitOrderBet = data => {
  const request = prepareRequest({
    url: 'ordering/bet:order',
    method: 'POST'
  })

  return request(data)
}

// Search

/*
  Searching Active Bet Orders
*/
export const searchActiveBetOrders = data => {
  const request = prepareRequest({
    url: 'ordering/bet/active:search',
    method: 'POST'
  })

  return request(data)
}

/*
  Searching Completed Bet Orders
*/
export const searchCompletedBetOrders = data => {
  const request = prepareRequest({
    url: 'ordering/bet/completed:search',
    method: 'POST'
  })

  return request(data)
}

/*
  Searching Active Bet Orders
*/
export const searchActiveCashoutOrders = ({ data, signal = null }) => {
  const request = prepareRequest({
    url: 'ordering/cash-out/active:search',
    method: 'POST',
    signal
  })
  return request(data)
}

/*
  Searching Completed Cashout Orders
*/
export const searchCompletedCashoutOrders = data => {
  const request = prepareRequest({
    url: 'ordering/cash-out/completed:search',
    method: 'POST'
  })

  return request(data)
}
